// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"78645d24","71":"b55951ec","289":"2db27b13"}[chunkId] + ".js";
};